if (!customElements.get('slideshow-swiper')) {
    class ImageSwiper extends HTMLElement {
        mySwiper;
        constructor() {
            super();

        }
        connectedCallback() {
            this.style.display = "block"
            this.mySwiper = new Swiper(this.querySelector('.slideshow-swiper'), {
                loop: this.getAttribute('data-loop'),
                autoplay: this.getAttribute('data-autoplay_speed') == 0 ? false : {
                    delay: this.getAttribute('data-autoplay_speed') * 1000,
                    pauseOnMouseEnter: this.getAttribute('data-pause_on_hover'),
                },
                slidesPerView: 1,
                centeredSlides: false,
                observer: true,
                // autoHeight: true,
                resizeObserver: true,
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                },
                pagination: {
                    el: this.querySelector(`.swiper-pagination`),
                    clickable: true,
                },
                on: {
                    // init: function (swiper) {
                    //     // 获取第一个slide的高度
                    //     var firstSlideHeight = swiper.slides[0].offsetHeight;
                    //     // 设置Swiper容器的高度
                    //     swiper.el.style.height = firstSlideHeight + 'px';
                    // },
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`.swiper-scrollbar`),
                },
            });
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {

        }

        initEvent(swiper) {

        }

    }
    customElements.define('slideshow-swiper', ImageSwiper);
}


